(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

  (() => {
    const setup = () => {
      document.querySelectorAll('product-page.main-product .product-text').forEach((content) => {
        if (content.dataset.dtWishlistConservationReady) return;
        content.dataset.dtWishlistConservationReady = 'true';
        const alignWishlist = () => {
          if (content.closest('[data-dt-gallery-pilot]')) return;
          const packHeading = Array.from(content.querySelectorAll('p, h2, h3, h4, strong')).find((element) => /^este pack incluye\s*:?$/i.test(element.textContent.replace(/\s+/g, ' ').trim()));
          const existingWineNames = {"10669377749339":"VEGA SICILIA UNICO 2016","10584289378651":"VEGA SICILIA VALBUENA 5º 2021","10560435650907":"ALION 2022","10560426246491":"MACÁN 2021","10584229478747":"MACAN CLASICO 2022","10584264638811":"PINTIA 2021","10584239669595":"OREMUS MANDOLÁS 2023","10421393523035":"VIÑA SASTRE ROBLE 2024","10423290200411":"VIÑA SASTRE ROBLE 2024 MAGNUM","10423178953051":"VIÑA SASTRE CRIANZA","10426951827803":"VIÑA SASTRE CRIANZA 2022 MAGNUM","10423199170907":"PAGO DE SANTA CRUZ 2022","10423217422683":"REGINA VIDES 2022","10460341993819":"Chula Lager","10584658936155":"Gran Leiriña 75cl","10421554643291":"LIRONDO 2025","10421550350683":"CANTAYANO 2025","10309402788187":"ARENISCA 2023","10309397545307":"MAJUELO DEL CHIVIRITERO 2023","7968423870759":"PAGO DE LOS CAPELLANES ROBLE 2025","7968422723879":"O LUAR DO SIL GODELLO 2025","9222100877659":"PAGO DE CARRAOVEJAS 2022","10309445583195":"DOMINIO DEL PIDIO 2021","10429499212123":"VIÑA ARDANZA RESERVA 2020","10232589123931":"VIÑA ALBERDI CRIANZA 2020","10232584667483":"FINCA SAN MARTÍN 2021","10232582078811":"ÁSTER EL ESPINO 2021","10232580997467":"LAGAR DE CERVERA 2024","7968442056999":"DOÑA TOMASA VERMOUTH","9222129516891":"TUSSIO 2024","10022635209051":"JOSÉ PARIENTE VERDEJO 2025","7968429506855":"HACIENDA EL TERNERO TORNO CRIANZA 2020","7968431374631":"Vino Blanco 'Habla de Ti'","10309589762395":"Castro Candaz · 75 cl","8856434901339":"Ultreia Godello 2024","10307355279707":"LABORES CHARDONNAY 75 CL","9644002378075":"Latúe Brut","8578503475547":"KOLOR OKUDA MENCÍA 2020"};
          const bodegaRow = content.querySelector('.dt-bodega-wishlist-row');
          const existingName = existingWineNames[content.dataset.dtBodegaProduct];
          if (bodegaRow && existingName) {
            const original = Array.from(content.querySelectorAll('p, h2, h3, h4')).find((element) => !bodegaRow.contains(element) && element.textContent.replace(/\s+/g, ' ').trim() === existingName);
            if (original) original.style.display = 'none';
          }
          const row = bodegaRow || packHeading || content.querySelector('.dt-product-conservation');
          if (packHeading) packHeading.classList.add('dt-pack-includes-row');
          const wishlist = content.querySelector('.frcp-wishlist-wrapper');
          if (!row || !wishlist) return;
          row.classList.add('dt-product-conservation-row');
          if (wishlist.parentElement !== row) row.appendChild(wishlist);
        };
        const observer = new MutationObserver(alignWishlist);
        observer.observe(content, { childList: true, subtree: true });
        alignWishlist();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup, { once: true });
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', setup);
  })();


(() => {
  const fit = () => {
    document.querySelectorAll('product-page.main-product .product-text ul[style*="list-style: disc outside"] li').forEach((item) => {
      if (!item.querySelector('.dt-north-first-line')) {
        const first = item.firstChild;
        if (first && first.nodeType === 3) {
          const match = first.textContent.match(/^(.*?del Norte)(.*)$/i);
          if (match) {
            const label = document.createElement('span');
            label.className = 'dt-north-first-line';
            label.textContent = match[1];
            first.textContent = match[2];
            item.insertBefore(label, first);
            if (match[2].trim()) {
              const lineBreak = document.createElement('br');
              lineBreak.className = 'dt-north-break';
              item.insertBefore(lineBreak, first);
            }
          }
        }
      }
      item.style.removeProperty('font-size');
      item.querySelectorAll('br').forEach((br) => {
        if (br.previousSibling && br.previousSibling.nodeType === 3 && !/\s$/.test(br.previousSibling.textContent)) br.previousSibling.textContent += ' ';
      });
      if (window.innerWidth >= 768) return;
      if (item.textContent.includes('Mejillones en Escabeche') && item.textContent.includes('Bateas Seleccionadas')) return;
      const range = document.createRange();
      range.selectNodeContents(item);
      const lines = () => new Set(Array.from(range.getClientRects()).filter((r) => r.width > 0 && r.height > 0).map((r) => Math.round(r.top))).size;
      let size = parseFloat(getComputedStyle(item).fontSize);
      while ((lines() > 2 || (item.querySelector('.dt-north-first-line') && item.querySelector('.dt-north-first-line').getBoundingClientRect().width > item.getBoundingClientRect().width)) && size > 10) {
        size -= 0.25;
        item.style.fontSize = size + 'px';
      }
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fit(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule, { once: true });
  if (document.fonts) document.fonts.ready.then(schedule);
})();


  } catch(e) { console.error(e); }
})();
})();
